// This function should never run because a value of type 'never' can never be
// constructed. This is useful in the 'default' case of a switch statement
// that's supposed to be exhaustive, for example. By passing the value in as a
// parameter to unreachable, the compiler will say what its type is. (e.g.
// "value of type 'Blue' is not assignable to type 'never'"), which can help
// explain what cases were missed.
//
// Because, however, our code is ultimately running as JavaScript, and there's
// nothing the type system can do to help us at run time, it's possible that
// unreachable() *does* get called. In that case, we log the value and throw an
// error.
export function unreachable(x) {
    console.log(x);
    throw new Error(`unexpected: ${x}`);
}
//# sourceMappingURL=unreachable.js.map